import React, { useEffect, useState } from "react";
import CustomInput from "../components/CustomInput";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import * as yup from "yup";
import { useFormik } from "formik";
import axios from "axios";
import { base_url } from "../utils/baseUrl";

// Validation schema
let schema = yup.object().shape({
  title: yup.string().required("Category Name is Required"),
  description: yup.string().required("Description is Required"),
});

const Addcat = () => {
  const navigate = useNavigate();
  const [categoryImage, setCategoryImage] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);
  const [imageError, setImageError] = useState(""); // For image-specific error

  const compressImage = async (file) => {
    return new Promise((resolve, reject) => {
      const img = new Image();
      const objectUrl = URL.createObjectURL(file);

      img.onload = () => {
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");

        const scaleFactor = Math.sqrt((250 * 1024) / file.size);
        canvas.width = img.width * scaleFactor;
        canvas.height = img.height * scaleFactor;

        ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

        canvas.toBlob(
          (blob) => {
            if (blob) resolve(blob);
            else reject("Compression failed");
          },
          "image/jpeg",
          0.7
        );
      };

      img.onerror = (err) => reject(err);
      img.src = objectUrl;
    });
  };

  const adminToken = localStorage.getItem("adminToken");
  console.log("Admin Token:", adminToken);

  useEffect(() => {
    const adminToken = localStorage.getItem("adminToken");
    if (!adminToken) navigate("/");
  }, [navigate]);

  const formik = useFormik({
    initialValues: {
      title: "",
      description: "",
    },
    validationSchema: schema,
    onSubmit: async (values) => {
      setImageError(""); // Reset image error

      if (!categoryImage) {
        setImageError("Image is required");
        return;
      }

      try {
        const formData = new FormData();
        formData.append("name", values.title);
        formData.append("description", values.description);

        const compressedImage =
          categoryImage.size > 250 * 1024
            ? await compressImage(categoryImage)
            : categoryImage;
        formData.append("image", compressedImage);

        await axios.post(`${base_url}/api/categories/create`, formData, {
          headers: { "Content-Type": "multipart/form-data" },
        });

        toast.success("Category Added Successfully!");
        navigate("/admin/list-category");
      } catch (error) {
        console.error(error);
        toast.error("Error adding category!");
      }
    },
  });

  const handleImageUpload = async (e) => {
    const file = e.target.files[0];
    if (file) {
      if (file.type !== 'image/jpeg' && file.type !== 'image/png') {
        toast.error("Please upload a valid image file (JPEG/PNG).");
        return;
      }

      let compressedFile = file;
      if (file.size > 250 * 1024) {
        compressedFile = await compressImage(file);
      }

      setCategoryImage(compressedFile);
      setImagePreview(URL.createObjectURL(compressedFile));
      setImageError(""); // Clear image error once uploaded
    }
  };

  return (
    <div>
      <h3 className="mb-4 title">Add Category</h3>
      <form onSubmit={formik.handleSubmit}>
        <CustomInput
          type="text"
          label="Enter Product Category"
          onChng={formik.handleChange("title")}
          onBlr={formik.handleBlur("title")}
          value={formik.values.title}
        />
        <div className="error">
          {formik.touched.title && formik.errors.title}
        </div>

        <textarea
          className="form-control my-3"
          rows="4"
          placeholder="Enter Product Description"
          onChange={formik.handleChange("description")}
          onBlur={formik.handleBlur("description")}
          value={formik.values.description}
        />
        <div className="error">
          {formik.touched.description && formik.errors.description}
        </div>

        <input
          type="file"
          accept="image/jpeg, image/png, image/jpg"
          className="form-control my-3"
          onChange={handleImageUpload}
        />
        <div className="error">
          {imageError && imageError}
        </div>
        {imagePreview && (
          <img src={imagePreview} alt="Category" width={200} height={200} />
        )}

        <button
          className="btn btn-success border-0 rounded-3 my-5"
          type="submit"
        >
          Add Category
        </button>
      </form>
    </div>
  );
};

export default Addcat;
